import { useState, useEffect } from 'react';
import { getSession } from './api';
import { UserSession } from '../types';

// 認証状態を管理するカスタムフック
export const useAuth = () => {
  const [user, setUser] = useState<UserSession | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // セッションをチェックする関数
  const checkAuth = async () => {
    try {
      setLoading(true);
      const sessionData = await getSession();
      if (sessionData && sessionData.email) {
        setUser({
          email: sessionData.email,
          userId: sessionData.userId,
          role: sessionData.role || 'user', // ロールが未設定の場合は一般ユーザーとする
        });
      } else {
        setUser(null);
      }
      setError(null);
    } catch (err) {
      console.error('認証エラー:', err);
      setUser(null);
      setError('認証情報の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  // コンポーネントマウント時に認証チェック
  useEffect(() => {
    checkAuth();
  }, []);

  // 管理者かどうかをチェックするヘルパー関数
  const isAdmin = (): boolean => {
    return user?.role === 'admin' || false;
  };

  return {
    user,
    loading,
    error,
    checkAuth,
    isAdmin,
  };
};

// 管理者のみがアクセスできるルートを保護するためのコンポーネント
export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user || !isAdmin()) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-2xl font-bold mb-4">アクセス権限がありません</h1>
        <p>この画面は管理者のみがアクセスできます。</p>
        <a
          href="/"
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          ホームに戻る
        </a>
      </div>
    );
  }

  return <>{children}</>;
};
